import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

const PartnersSection: FC = () => {
	const { transData } = useTranslation('partner.partners');
	const { width } = useResizeObserver();
	return (
		<section className={styles['ac-partner-logo']}>
			{width >= 1192 && <img src="https://web-data.zmlearn.com/image/gwYFX3UsJLFbQBC2jRX9iu/img_p1_star%20%402x.png" alt="" />}
			<div className={styles['ac-partner-logo-container']}>
				<div className={styles.title} dangerouslySetInnerHTML={{ __html: transData.title }}></div>
				<div className={styles['description-desc']} dangerouslySetInnerHTML={{ __html: transData.p1 }} />
				<div className={styles['description-desc']} dangerouslySetInnerHTML={{ __html: transData.p2 }} />
			</div>
		</section>
	);
};

export default PartnersSection;
